var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.956 0a2.934 2.934 0 0 1 2.933 2.932v18.136A2.934 2.934 0 0 1 21.956 24H3.821a2.934 2.934 0 0 1-2.932-2.932V2.932A2.934 2.934 0 0 1 3.82 0zM8.41 19.841V9.261H4.893v10.58zm12.682 0v-6.067c0-3.25-1.735-4.762-4.05-4.762-1.865 0-2.7 1.026-3.169 1.747V9.26h-3.516c.046.993 0 10.58 0 10.58h3.516v-5.909c0-.316.023-.632.116-.858.254-.632.833-1.286 1.804-1.286 1.272 0 1.782.97 1.782 2.392v5.661h3.517ZM6.675 4.16c-1.203 0-1.99.791-1.99 1.828 0 1.015.763 1.828 1.944 1.828h.022c1.227 0 1.99-.813 1.99-1.828-.022-1.035-.76-1.826-1.966-1.828",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.889 0h24v24h-24z"
  })))));
};
export default SvgLinkedin;